import { render, staticRenderFns } from "./PrevisaoFatura.vue?vue&type=template&id=465f0f70&scoped=true&"
import script from "./PrevisaoFatura.vue?vue&type=script&lang=js&"
export * from "./PrevisaoFatura.vue?vue&type=script&lang=js&"
import style0 from "./PrevisaoFatura.vue?vue&type=style&index=0&id=465f0f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f0f70",
  null
  
)

export default component.exports